// import { get, post } from '@/service/request';
import { post, get } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/transaction/record';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 交易紀錄查詢 */
export function getRecord(data) {
    return post(`${url}/`, data, { ...options, repeatRequestCancel: true });
};

/** 下載交易紀錄PDF(需登入) */
export function exportPdfRecord(data) {
    return post(`${url}/exportPdf`, { regiNo: data }, { ...options, responseType: 'blob' });
}

/** 產生交易紀錄下載連結參數 */
export function getPdfRecordToken(regiNo) {
    return get(`${url}/getToken?regiNo=${regiNo}`, { ...options });
}

/** 產生交易紀錄下載連結參數 */
export function getCecPdfRecordToken(regiNo) {
    return get(`${url}/getCecToken?regiNo=${regiNo}`, { ...options });
}

/** 補發繳費授權 */
export function reSendLinkPay(data) {
    return post(`${url}/reSendLinkPay`, { regiNo: data }, { ...options });
}

export function postCecRecord(data) {
    return post(`${url}/cecRecord`, { regiNo: data }, { ...options });
}

export function postCancelTransaction(data) {
    return post(`${url}/cancelTransaction`, { regiNo: data }, { ...options });
}
